import React, { useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import LoadingView from './LoadingView';

export default function SharedAuthCallbackView(): JSX.Element {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const authType = searchParams.get('auth_type');

  useEffect(() => {
    if (authType === 'auth0') {
      window.location.replace(`/auth0${location.pathname}${location.search}`);
    } else if (authType === 'platform') {
      window.location.replace(`/platform-auth${location.pathname}${location.search}`);
    }
  }, [authType, location.pathname, location.search]);

  return <LoadingView />;
}
